import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import "./index.css";
import { I18nProvider } from "./components/languages";

console.log(
  "Welcome to Is It Cinematic! If you're interested in downloading all data, " +
    "please use https://www.isitcinematic.com/assets/games/summary.json.br " +
    "It is Brotli compressed json file. Happy scraping!",
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <I18nProvider>
        <App />
      </I18nProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
